import FormComponent from '../FormComponent';

class TournamentEventDetails extends FormComponent {
	markup(value, data, titleMarkup) {
		this.eventDetails = {};
		return `
            <div class="lta-input-field-title">${titleMarkup}</div>
            <div class="u-px-3 u-py-2 u-mb-3 u-bg-background-blue u-rounded">
                <table>
                    <tr class="lta-autosuggest-input-result_event-details-mini u-mb-1">
                        <td class="u-body2">Event days:</td>
                        <td class="u-h6">Mini - ${data.value.miniDays}</td>
                    </tr>
                    <tr class="lta-autosuggest-input-result_event-details-junior u-mb-1">
                        <td class="u-body2"></td>
                        <td class="u-h6">Junior - ${data.value.juniorDays}</td>
                    </tr>
                    <tr class="lta-autosuggest-input-result_event-details-open u-mb-1">
                        <td class="u-body2"></td>
                        <td class="u-h6">Open - ${data.value.openDays}</td>
                    </tr>
                    <tr class="lta-autosuggest-input-result_event-details-senior u-mb-1">
                        <td class="u-body2"></td>
                        <td class="u-h6">Senior - ${data.value.seniorDays}</td>
                    </tr>
                    <tr class="lta-autosuggest-input-result_event-details-noOfEvents u-mb-1">
                        <td class="u-body2">No of events:</td>
                        <td class="u-h6">${data.value.noOfEvents}</td>
                    </tr>
                    <tr class="lta-autosuggest-input-result_event-details-noOfEntries u-mb-1">
                        <td class="u-body2">No of entries:</td>
                        <td class="u-h6">${data.value.noOfEntries}</td>
                    </tr>
                </table>
            <div>
        `;
	}

	afterRender() {
		if (this.data.value) {
			this.eventDetails = {
				miniDays: this.data.value.miniDays,
				juniorDays: this.data.value.juniorDays,
				openDays: this.data.value.openDays,
				seniorDays: this.data.value.seniorDays,
				noOfEvents: this.data.value.noOfEvents,
				noOfEntries: this.data.value.noOfEntries
			};
			setTimeout(() => {
				this.handleChange();
			}, 100);
		}
	}

	handleChange() {
		this.value = { ...this.data, value: this.eventDetails };
	}

	validate() {
		return true;
	}
}
export default TournamentEventDetails;
